import React from 'react'
import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

function SelectVProp2({
    FBvalueProp,
    valueIndex,
    selectedVprop,
}) {
    return (
    <Listbox value={valueIndex} onChange={(e) => selectedVprop(e)}>
        {({ open }) => (
          <>
            {/* <Listbox.Label className="block text-sm font-medium text-gray-700">Assigned to</Listbox.Label> */}
            <div className="mt-1 ml-2 relative">
              <Listbox.Button className="relative w-56 bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                <span className="w-full inline-flex truncate">
                  <span className="truncate">{FBvalueProp[valueIndex]?.Title}</span>
                  <span 
                  className={classNames(FBvalueProp[valueIndex]?.ContextType === 'template' ? 'text-white font-medium bg-yellow-700 rounded-full px-2' : 'text-gray-500 ', 'ml-2')}
                  >
                      {FBvalueProp[valueIndex]?.ContextType}</span>
                </span>
                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                  <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </Listbox.Button>
  
              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options
                  static
                  className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                >
                  {FBvalueProp.map((vprop, index) => (
                    <Listbox.Option
                      key={index}
                      className={({ active }) =>
                        classNames(
                          active ? 'text-white bg-indigo-600' : 'text-gray-900',
                          'cursor-default select-none relative py-2 pl-3 pr-9'
                        )
                      }
                      value={index}
                      >
                      {({ valueIndex, active }) => (
                        <>
                          <div className="flex">
                            <span className={classNames(valueIndex ? 'font-semibold' : 'font-normal', 'truncate')}>
                              {vprop?.Title}
                            </span>
                            <span className={classNames(vprop?.ContextType === 'template' ? 'text-white font-medium bg-yellow-700 rounded-full px-2' : 'text-gray-500 ', 'ml-2')}>
                              {vprop?.ContextType}
                            </span>
                          </div>
  
                          {valueIndex ? (
                            <span
                              className={classNames(
                                active ? 'text-white' : 'text-indigo-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4'
                              )}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    )
}

export default SelectVProp2
